(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // controller for agenda appointment time past modal 
    module.controller('AgendaAppointmentDetailUserIsBeingModifiedPopupController',
        ['$uibModalInstance', 'firstName', 'newFirstName', 'lastName', 'newLastName', AgendaAppointmentDetailUserIsBeingModifiedPopupControllerFn]);

    function AgendaAppointmentDetailUserIsBeingModifiedPopupControllerFn($uibModalInstance, firstName, newFirstName, lastName, newLastName) {
        var vm = this;

        vm.firstName = firstName;
        vm.lastName = lastName;
        vm.newFirstName = newFirstName;
        vm.newLastName = newLastName;
        // update appointment
        vm.update = function () {
            $uibModalInstance.close(true);
        };

        // book appointment ->  block = false
        vm.cancel = function () {
            $uibModalInstance.close(false);
        };

    }

})();